import React from 'react';
import { useSelector } from 'react-redux';
import { Tag } from '../common';
import { v2Color } from '@theme/v2';

const TruBrokerTag = ({ tagText, size, tagFontSize, padding, borderRadius, style }) => {
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);

  const styles = {
    background: `linear-gradient(237.73deg, ${v2Color('#053940')} 19.63%, ${v2Color('#00745F')} 48.96%, ${v2Color('#033F46')} 72.03%)`,
    display: 'inline-block',
    alignItems: 'center',
    borderRadius: borderRadius || isMobile ? '4px' : '6px',
    padding: padding || isMobile ? '4px 6px' : '5px 8px',
    width: 'max-content',
    '--tag-font-size': tagFontSize || isMobile ? '11px' : '12px',
    ...style,
  };

  return (
    <Tag style={styles} color={v2Color('#00745F')} textColor="#fff" gradient size={size}>
      {tagText}
    </Tag>
  );
};

export default TruBrokerTag;
